var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"small":"","text":"","color":"primary"},on:{"click":_vm.exportUsers}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-download")]),_vm._v(" Tout Exporter ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }